import { useIntl } from 'react-intl';
import { TimesheetLabel } from 'modules/timesheet-labels/labelSchema';
import { LabelType } from 'graphql/types';

export const useLabelName = (label?: TimesheetLabel | null): string => {
  const { formatMessage } = useIntl();
  if (
    label?.type &&
    ![LabelType.Select, LabelType.Text, LabelType.Numeric].includes(label?.type)
  )
    return formatMessage({ id: `labelType.${label?.type}` });
  return label?.name || '';
};
